import React, {useEffect,useState} from 'react';
import axios from 'axios';
import {Button, HStack, Text} from '@chakra-ui/react';
import {Link} from 'react-router-dom';

export default function ConversationAccountLinks({identity,userId}:{identity:string;userId?:string}) {
  const [account,setAccount]=useState<any>(null),[failed,setFailed]=useState(false),[retry,setRetry]=useState(0);
  useEffect(()=>{
    let current=true;setAccount(null);setFailed(false);
    axios.post(`${process.env.REACT_APP_BASE_URL || 'https://api.pureworker.com/api'}/admin/conversation-identities`,
      {identities:[{identity,user_id:userId}]},{withCredentials:true,timeout:15000,headers:{Authorization:`Bearer ${localStorage.getItem('AuthToken')}`}})
      .then(r=>{if(current)setAccount(r.data.identities?.find((a:any)=>a.identity===identity));})
      .catch(()=>{if(current)setFailed(true);});
    return ()=>{current=false;};
  },[identity,userId,retry]);
  if(failed)return <Button size="xs" variant="link" onClick={()=>setRetry(r=>r+1)}>Retry profile lookup</Button>;
  if(!account)return null;
  if(!account.found||!account.user_id)return <Text fontSize="xs" color="admin.muted">{account.match_status==='ambiguous'?'Multiple accounts match this number':'No registered account linked'}</Text>;
  const provider=['freelancer','contractor'].includes(account.account_type);
  return <HStack mt={2} flexWrap="wrap">
    <Button as={Link} size="xs" variant="outline" to={`/${provider?'provider':'customers'}/${encodeURIComponent(account.user_id)}`}>View profile</Button>
    <Button as={Link} size="xs" variant="outline" to={`/chat?user=${encodeURIComponent(account.user_id)}`}>Support chat</Button>
  </HStack>;
}
